/**
 * SCRUM-92 (DS-008-9) — transfer-ownership.schema.ts
 *
 * Zod schema for POST /organizations/:slug/properties/:propertyId/ownership/transfer
 * request body (endpoint #3).
 */
import { z } from 'zod';
export const transferOwnershipSchema = z.object({
    fromUserId: z.string().uuid(),
    toUserId: z.string().uuid(),
    /** ISO 8601 datetime. Defaults to now at the UC layer when omitted. */
    transferredAt: z.string().datetime().optional(),
});
//# sourceMappingURL=transfer-ownership.schema.js.map